// extracted by mini-css-extract-plugin
export default {"lable":"HolidayCalender_lable__VZQOW","dropdown":"HolidayCalender_dropdown__Pz3AQ","updateButton":"HolidayCalender_updateButton__r7UDO"};